import React from 'react';
import { useFirestoreDocs } from '../hooks/useFirestoreDocs';
import MarkdownRenderer from '../components/MarkdownRenderer';

/**
 * Vista Dinámica de Documentación para Repartidores & Conductores (Firestore + Redux + Markdown)
 */
export default function DriverDocs() {
  const { docs, loading } = useFirestoreDocs('repartidores');

  if (loading) {
    return (
      <div style={{ padding: '40px', textAlign: 'center', color: '#64748b', fontWeight: 300 }}>
        Cargando guía de repartidores...
      </div>
    );
  }

  return (
    <div className="driver-docs-container">
      {docs.map((docItem) => (
        <section key={docItem.id} id={docItem.id} className="doc-section" style={{ marginBottom: '2.5rem' }}>
          <MarkdownRenderer content={docItem.contenidoMarkdown} />
        </section>
      ))}
    </div>
  );
}
